export const MONTHS_IN_YEAR = 12;
export const MONTHLY_INTEREST_RATE = MONTHS_IN_YEAR * 100;
export const DEFAULT_MIN_MONTHS = 1;
export const DEFAULT_MAX_MONTHS = 60;
export const DEFAULT_MONTHS = Math.round((DEFAULT_MAX_MONTHS - DEFAULT_MIN_MONTHS) / 2);
//# sourceMappingURL=calculatorConstants.js.map